import { APILayer as API } from "./APILayer"

export const PostController = {
    getPost: async function (pageName) {
        return API.getbyName('/post', pageName);
    },
    getSiteMap: async function (pageName) {
        return API.getbyName('/site', pageName);
    }
}